import { Injectable, ErrorHandler, inject } from '@angular/core';
import { LoggerService } from '@shared/services/logger.service';

@Injectable({ providedIn: 'root' })
export class AppErrorHandler implements ErrorHandler {
  #logger = inject(LoggerService);

  public Tag = 'IPMAppErrorHandler';

  public handleError(error: any): void {
    this.#logger.error(this.Tag + ' Error =>' + error, error);
  }
}
